import { useMedia } from 'hooks/useMedia'
import { breakpoints } from 'styles/mq'

export const MenuIcon = () => {
  const isMobile = !useMedia([breakpoints.medium], [true], false)

  return isMobile ? (
    <svg
      width="1em"
      viewBox="0 0 20 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line y1="1" x2="19.0604" y2="1" stroke="currentColor" strokeWidth="2" />
      <line
        y1="7.5"
        x2="19.0604"
        y2="7.5"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        y1="14"
        x2="19.0604"
        y2="14"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  ) : (
    <svg
      width="1em"
      viewBox="0 0 37 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <line y1="1" x2="36.7133" y2="1" stroke="currentColor" strokeWidth="2" />
      <line
        y1="13.4473"
        x2="36.7133"
        y2="13.4473"
        stroke="currentColor"
        strokeWidth="2"
      />
      <line
        y1="25.8946"
        x2="36.7133"
        y2="25.8946"
        stroke="currentColor"
        strokeWidth="2"
      />
    </svg>
  )
}
